import { FunctionalAutomationOverviewComponent } from './../_shared/overview/functional-automation-overview/functional-automation-overview.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@app/_guards';

import { MainLayoutComponent } from '@app/layout/main-layout/main-layout.component';
import { LoginFormComponent } from '@app/_shared/login-form/login-form.component';
import { ComingSoonComponent } from '@app/coming-soon/coming-soon.component';
import { SessionGuard } from '@app/_guards/session.guard';
import { UnauthorizedComponent } from '@app/unauthorized/unauthorized.component';

const routes: Routes = [
    { path: '', redirectTo: '/home', pathMatch: 'full' },
    { path: 'login', component: LoginFormComponent },
    // { path: 'coming-soon', component: ComingSoonComponent },

    {
        path: '',
        component: MainLayoutComponent,
        children: [
            // { path: 'home', loadChildren: () => import('../new-homepage/new-homepage.module').then(m => m.NewHomepageModule), canActivate: [SessionGuard] },
            { path: 'overview', component: FunctionalAutomationOverviewComponent },
            { path: 'home', loadChildren: () => import('../home/home.module').then(m => m.HomeModule), canActivate: [SessionGuard] },
            { path: 'endpoint', loadChildren: () => import('../endpoint/endpoint.module').then(m => m.EndpointModule) },
            { path: 'testcase', loadChildren: () => import('../testcase/testcase.module').then(m => m.TestcaseModule) },
            { path: 'testsuite', loadChildren: () => import('../testsuite/testsuite.module').then(m => m.TestsuiteModule) },
            { path: 'mastersuite', loadChildren: () => import('../mastersuite/mastersuite.module').then(m => m.MatersuiteModule) },
            { path: 'gopher', loadChildren: () => import('../gopher/gopher.module').then(m => m.GopherModule) },
            { path: 'performance', loadChildren: () => import('../performance/performance.module').then(m => m.PerformanceModule) },
            { path: 'user', loadChildren: () => import('../user/user.module').then(m => m.UserModule) },
            { path: 'history', loadChildren: () => import('../execution-history/execution-history.module').then(m => m.ExecutionHistoryModule) },
            { path: 'results', loadChildren: () => import('../execution-history/execution-history.module').then(m => m.ExecutionHistoryModule) },
            { path: 'help', loadChildren: () => import('../help/help.module').then(m => m.HelpModule) },
            { path: 'chaos', loadChildren: () => import('../chaos/chaos.module').then(m => m.ChaosModule) },
            { path: 'gremlin', loadChildren: () => import('../gremlin/gremlin.module').then(m => m.GremlinModule) },
            { path: 'awsFis', loadChildren: () => import('../aws-fis/aws-fis.module').then(m => m.AwsFisModule) },
            { path: 'mobileAutomation', loadChildren: () => import('../mobile-automation/mobile-automation.module').then(m => m.MobileAutomationModule) },
            { path: 'desktopAutomation', loadChildren: () => import('../desktop-automation/desktop-automation.module').then(m => m.DesktopAutomationModule) },
            { path: 'unauthorized', component: UnauthorizedComponent},
            { path: 'coming-soon', component: ComingSoonComponent },
        ],
        runGuardsAndResolvers: 'always'
    },
    { path: '**', redirectTo: '/coming-soon' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LayoutRoutingModule {}
